<script lang="ts">import { stateUi } from "@infinitro/config";
import { TickIcon, TickIconAlternative } from "@infinitro/icons";
let { id = "custom-checkbox", checked = $bindable(false), label = null, description = null, disabled = false, onChange } = $props();
const useAlternative = $derived($stateUi.checkbox.checkboxStyle === "alternative");
const useAlternative2 = $derived($stateUi.checkbox.checkboxStyle === "alternative2");
const useAlternative4 = $derived($stateUi.checkbox.checkboxStyle === "alternative4");
const handleCheckboxChange = (event) => {
	checked = event.target.checked;
	onChange?.({ checked });
};
</script>

<div class="custom-checkbox-container">
	<span class="custom-checkbox-input-container">
		<input
			type="checkbox"
			{id}
			bind:checked
			{disabled}
			class="custom-checkbox"
			class:alternative-custom-checkbox={useAlternative}
			class:alternative2-custom-checkbox={useAlternative2}
			class:alternative4-custom-checkbox={useAlternative4}
			onchange={handleCheckboxChange}
		/>
		<label for={id} class="custom-checkbox-label-container">
			{#if checked}
				{#if $stateUi.checkbox.useAlternativeTick}
					<div class="alternative-icon-container">
						<TickIconAlternative className="custom-checkbox-tick-icon" />
					</div>
				{:else}
					<TickIcon
						className="custom-checkbox-tick-icon {useAlternative2 ? 'alternative2-tick-icon' : ''}"
					/>
				{/if}
			{/if}
		</label>
	</span>
	{#if label}
		<label for={id} class="custom-checkbox-text">{label}</label>
	{/if}
</div>
{#if description}
	<p class="description">{description}</p>
{/if}

<style>
	.custom-checkbox-container {
		display: flex;
		flex-direction: row;
		align-items: center;
		gap: 0.5rem;
		font-family: var(--font-main);
}

	.custom-checkbox-input-container {
		position: relative;
		display: flex;
		align-items: center;
}

	.custom-checkbox {
		height: 1.25rem;
		width: 1.25rem;
		-webkit-appearance: none;
		   -moz-appearance: none;
		        appearance: none;
		border-radius: 0.25rem;
		border-width: 1px;
		border-color: var(--color-neutral-900);
		background-color: var(--color-background-100);
		outline: 2px solid transparent;
		outline-offset: 2px;
		transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
		transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
		transition-duration: 300ms;
		cursor: pointer;
}

	.alternative-custom-checkbox {
		border-color: var(--color-primary-500);
}

	.custom-checkbox:disabled {
		cursor: not-allowed;
		opacity: 0.3;
}

	.custom-checkbox:active {
		border-color: var(--color-secondary-500);
}

	.alternative-custom-checkbox:active {
		border-color: var(--color-primary-500);
}

	.custom-checkbox:checked {
		border-color: var(--color-secondary-500);
		background-color: var(--color-secondary-500);
		background-image: none;
}

	.alternative-custom-checkbox:checked {
		border-color: var(--color-highlight-2);
}

	.alternative2-custom-checkbox {
		position: relative;
		border-style: none;
		background: radial-gradient(
			100% 100% at 0% 50%,
			var(--color-tertiary-300) 0%,
			var(--color-tertiary-700) 100%
		);
}

	.alternative2-custom-checkbox::before {
		content: '';
		position: absolute;
		inset: 0;
		border-radius: inherit;
		padding: 1px;
		background: linear-gradient(180deg, var(--color-text-500) 0%, transparent 100%);
		-webkit-mask:
			linear-gradient(#fff 0 0) content-box,
			linear-gradient(#fff 0 0);
		-webkit-mask-composite: xor;
		mask-composite: exclude;
		pointer-events: none;
		z-index: 2;
	}

	.alternative2-custom-checkbox:checked {
		background: radial-gradient(
			ellipse 120% 200% at left,
			rgb(var(--color-primary-500-rgb) / 0.3) 0%,
			rgb(var(--color-primary-500-rgb) / 0.8) 100%
		);
	}

	.alternative2-custom-checkbox:checked::before {
		background: linear-gradient(180deg, var(--color-secondary-300) 0%, transparent 100%);
	}
	.alternative4-custom-checkbox {
		border-color: var(--color-accent-100);
}
	.alternative4-custom-checkbox:active {
		border-color: var(--color-primary-300);
}
	.alternative4-custom-checkbox:checked {
		border-color: var(--color-primary-300);
		background-color: var(--color-primary-300);
}

	.custom-checkbox-label-container {
		pointer-events: none;
		position: absolute;
		top: 0px;
		left: 0px;
		display: flex;
		height: 1.25rem;
		width: 1.25rem;
		align-items: center;
		justify-content: center;
}

	:global(.custom-checkbox-tick-icon) {
		margin: auto;
		margin-left: 0.25rem;
		width: 70%;
		height: 70%;
}
	:global(.alternative2-tick-icon) {
		filter: brightness(0) invert(1);
		position: relative;
		left: 1px;
		top: 1px;
	}
	.alternative-icon-container {
		position: absolute;
		top: -1px;
		left: 5px;
		--tw-scale-x: 1.3;
		--tw-scale-y: 1.3;
		transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
	.custom-checkbox-text {
		font-size: 10px;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
	@media (min-width: 640px) {

		.custom-checkbox-text {
				font-size: 0.875rem;
				line-height: 1.25rem;
		}
}

	.description {
		margin-top: 0.5rem;
		font-size: 0.75rem;
		line-height: 1rem;
		--tw-text-opacity: 1;
		color: rgb(156 163 175 / var(--tw-text-opacity, 1));
		font-family: var(--font-main);
}
</style>
